import type { Agency } from '@saaga/shared/interfaces/agencies.interface'
import type { ReactNode } from 'react'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'

import { getAgencyInitials } from './agency.util'

interface AgencyDetailAvatarProps {
  agency: Agency
}

export const AgencyDetailAvatar = ({ agency }: AgencyDetailAvatarProps): ReactNode => (
  <Avatar className="agency-detail-avatar size-20 md:size-24 rounded-xl">
    {agency.logoUrl && <AvatarImage src={agency.logoUrl} alt={agency.name} />}
    <AvatarFallback className="rounded-xl bg-primary/10 text-primary text-2xl">
      {getAgencyInitials(agency.name)}
    </AvatarFallback>
  </Avatar>
)

AgencyDetailAvatar.displayName = 'AgencyDetailAvatar'
